import { http } from '../../config/axios'

export default function postFaturaManual(data: any): Promise<string> {
    return http.post('/api/fatura/manual', data)
        .then((r) => r.data)
        .catch((error) => {
            console.error('Erro ao criar fatura manual')
            throw error
        })
}
